/**
 * English strings of the installed web app (milestone 8): the notice that a new version is ready, the
 * one that the game now works without a network, and the install button. `pwa-it.ts` is typed against this shape.
 */
export const pwaEn = {
  pwa: {
    updateReady: 'A new version of the game is ready.',
    update: 'Update',
    later: 'Later',
    offlineReady:
      'The game is saved on this device: Solo, Training and the Tutorial work without a network.',
    install: 'Install the app',
    installNote: 'Opens from the home screen or the desktop, in a window of its own.',
    installed: 'The app is installed.',
  },
};
